
import Alert from 'vux/src/components/alert/index.vue'

import {HotelProxy} from '@/http/RequestProxy.class';

export default {
name: 'allinpay-requirement',
components: {
Alert,
},
data(){
return {
isShowSecurityCodeTips: false,  // 是否显示安全码示例

cardOptions: {
cardNumber: '',       // 信用卡号
cardHolderName: '',   // 持卡人姓名
cardExpireDate: '',   // 卡片到期日
securityNumber: '',   // 安全码
},

cardRegexps: [],      // 卡类型正则表达式
cardImgPath: '/m/static/images/payment/default-card.png', // 卡片类型图标路径
};
},
watch: {
cardOptions: {
handler: function(newOptions){
this.returnCardInfo(newOptions);
},
deep: true,
},
},
created(){
this.getCardRegexp();
},
methods: {
/** 获取卡号类型正则表达式 */
getCardRegexp(){
new HotelProxy().getHotelConfig()
.then(resp => {
if(resp){
this.cardRegexps = resp.data.regex;
}
});
},

/** 返回信用卡信息 */
returnCardInfo(newOptions){
this.$nextTick(() => {
this.$emit('on-get-card', newOptions);
});
},

/** 信用卡号输入处理 */
onInputCardNumber(){
let originVal = this.cardOptions.cardNumber,
currentVal = originVal.replace(/\s/g, ''),
imgPath = '',
result = '';


for(let k = 0; k < this.cardRegexps.length; k++){
let item = this.cardRegexps[k];
let reg = new RegExp(item['regexp']);

if(reg.test(currentVal)){
if(item['name'] === 'JCB'){
imgPath = '/m/static/images/payment/jcb-card.png';
}else if(item['name'] === 'VISA'){
imgPath = '/m/static/images/payment/visa.png';
}else if(item['name'] === 'MASTECARD'){
imgPath = '/m/static/images/payment/master.png';
}else if(item['name'] === 'AMEX'){
imgPath = '/m/static/images/payment/wanshida.png';
}
break ;
}else{
imgPath = '/m/static/images/payment/default-card.png';
}
}

for(let i = 0; i < currentVal.length; ){
result += currentVal.substr(i, 4) + ' ';
i += 4;
}

this.cardImgPath = imgPath;
this.cardOptions.cardNumber = result.replace(/\s$/, '');
},

/** 卡号到期日 */
onInputCardDate(ev){
let keyCode = ev.keyCode,
originVal = this.cardOptions.cardExpireDate,
currentVal = originVal.replace(/\//g, ''),
result = '';

if(keyCode !== 8 && originVal.length >= 2){
result = currentVal.substr(0, 2) + '/' + currentVal.substr(2);
this.cardOptions.cardExpireDate = result;
}
},

/** 显示安全码提示内容 */
onShowSecurityCodeTips(){
this.isShowSecurityCodeTips = true;
},
},
}



// WEBPACK FOOTER //
// ./src/views/payment/components/AllinpayRequirement.vue